<template>    
  <form class="app" @submit.prevent="onLogin" novalidate>
    <p v-if="selectId!= 3" aria-label="All fields are required" class="req-field">All fields are required.</p>
    <p v-if="selectId == 3" aria-label="* required field" class="app-required-indicator __before req-field">required field</p>
    <div class="app-input-row">
      <!-- Last Name -->
      <div class="app-input-group" :class="{ 'app-invalid-group': !isNameValid }">
        <label :for="nameField" class="inputclass" :class="{'app-required-indicator __after': selectId == 3}">Last name <span class="subText"  v-if="selectId == 1">(as on your License / ID Card)</span></label>
        <input type="text" :id="nameField" :aria-describedby="`${nameField}Desc`"
              v-model="myName" @input="validateName" aria-required="true" />
        <p v-if="!isNameValid" class="app-error-message">{{ nameError }}</p>
        <p :id="`${nameField}Desc`" class="sr-only">{{ getFieldDescription(`${nameField}`) }}</p>
        <p :id="`${nameField}Desc`" class="sr-only">Required. Up to 40 characters. Do not use comma, semicolon, less-than sign or pipe.</p>
      </div>

      <!-- DOB -->    
      <div class="app-input-group" :class="{ 'app-invalid-group': !isDateSupported }">
        <label :for="dateField" class="inputclass" :class="{'app-required-indicator __after': selectId == 3}">Date of birth</label>
        <input type="date" :id="dateField" :aria-describedby="`${dateField}Desc`"
              v-model="myDob" @input="validateDob" aria-required="true" />
        <p v-if="!isDateSupported" class="app-error-message">{{ dobError }}</p>
        <p :id="`${dateField}Desc`" class="sr-only">{{ getFieldDescription(`${dateField}`) }}</p>
        <p id="dobDesc" class="sr-only">Required in mm/dd/yyyy format.</p>
      </div>

      <!-- SSN -->
      <div class="app-input-group" :class="{ 'app-invalid-group': !isSsnValid }" v-if="selectId == 1">
        <label :for="ssnField">Last four digits of SSN</label>
        <input class="fourdigitssn" :type="inputType" maxlength="4" @input="onlyNumbers($event, 'myLastSsn')" :id="ssnField" :aria-describedby="`${ssnField}Desc`"
              v-model="myLastSsn" aria-required="true"/>
        <button type="button" class="app-btn-image" role="button" @click='toggleHidden()'>
          <img src="@ridmv/web-themes/images/icons/eye-solid.svg" alt="Show or Hide last four digits of ssn">
          <span class="sr-only">Show or hide last four of ssn</span>
        </button>
        <p v-if="!isSsnValid" class="app-error-message">{{ ssnError }}</p>
        <p :id="`${ssnField}Desc`" class="sr-only">{{ getFieldDescription(`${ssnField}`) }}</p>
      </div>
      
      <!-- Case/Ticket  Number-->
      <div class="app-input-group" :class="{ 'app-invalid-group': !isCaseNumberValid }" v-if="selectId == 3">
        <div class="d-flex">
          <label :for="caseNumberField" class="inputclass app-required-indicator __after"> 
            Case / Summons / Ticket number
          </label>
        </div>
        <input type="text" :id="caseNumberField" :aria-describedby="`${caseNumberField}Desc`"
              v-model="myCaseNumber" @input="validateCaseNumber" aria-required="true" />
        <p v-if="!isCaseNumberValid" class="app-error-message">{{ caseNumberError }}</p>
        <p :id="`${caseNumberField}Desc`" class="sr-only">{{ getFieldDescription(`${caseNumberField}`) }}</p>
        <p :id="`${caseNumberField}Desc`" class="sr-only">Required. Up to 18 characters.</p>
      </div>
    </div>

    <div class="app-input-row"  v-if="selectId == 1">
      <!-- License -->
      <div class="app-input-group" :class="{ 'app-invalid-group': !isLicenseValid }">
      <label :for="licenseField" class="inputclass">RI License / ID #</label>
      <input type="text" maxlength="8" :id="licenseField" :aria-describedby="`${licenseField}Desc`"
            v-model="myLicense" @input="validateLicense" aria-required="true" />
      <p v-if="!isLicenseValid" class="app-error-message">{{ licenseError }}</p>
      <p :id="`${licenseField}Desc`" class="sr-only">{{ getFieldDescription(`${licenseField}`) }}</p>
      <p :id="`${licenseField}Desc`" class="sr-only">Required. Up to 8 characters. Do not use comma, semicolon, less-than sign or pipe.</p>
      </div>
    </div>

    <!-- /* This div will open when user selects vehicle type*/ -->
    <div class="app-input-row" v-if="selectId == 2">
    <!-- Plate Number -->
      <div class="app-input-group " :class="{ 'app-invalid-group': !isPlateValid }">
        <label :for="plateField">Plate number</label>
        <input class="plate" type="text" maxlength="7" :id="plateField" :aria-describedby="`${plateField}Desc`"
              v-model.lazy.trim="myPlateNumber" aria-required="true" />
        <p v-if="!isPlateValid" class="app-error-message">{{ plateError }}</p>
        <p :id="`${plateField}Desc`" class="sr-only">{{ getFieldDescription(`${plateField}`) }}</p>
      </div>

      <!-- Registration Type -->
      <div class="app-input-group " :class="{ 'app-invalid-group': !isTypeValid }">
        <label :for="typeField">Plate type</label>
        <select class="app-custom-select" :id="typeField" :aria-describedby="`${typeField}Desc`"
                v-model.lazy="myPlateType" aria-required="true">
          <option :value="{ code: 'none' }">Select a type</option>
          <option v-for="type in registrationTypes" :value="{ code: type.vehiclePlateTypeId, description: type.description }" :key="type.vehiclePlateTypeId">
            {{ type.description }}
          </option>
        </select>
        <p v-if="!isTypeValid" class="app-error-message">{{ typeError }}</p>
        <p :id="`${typeField}Desc`" class="sr-only">{{ getFieldDescription(`${typeField}`) }}</p>
      </div>

      <!-- Last 6 VIN Digits -->
      <div class="app-input-group" :class="{ 'app-invalid-group': !isVinValid }">
        <label :for="vinField">Last six digits of VIN</label>
        <input class="vin" type="text" maxlength="6" :id="vinField" :aria-describedby="`${vinField}Desc`"
              v-model.lazy.trim="myLastVin" aria-required="true" />
        <p v-if="!isVinValid" class="app-error-message">{{ vinError }}</p>
        <p :id="`${vinField}Desc`" class="sr-only">{{ getFieldDescription(`${vinField}`) }}</p>
      </div>
    </div>

    <!-- /* This div will open when user selects violation/suspension*/ -->
      <p v-if="selectId == 3"> Please enter one of the following</p>
      <div class="app-input-row" v-if="selectId == 3">
        <div class="app-input-group app-input-model" :class="{ 'app-invalid-group': !isViolationDateSupported }">
        <label :for="violationDateField" class="inputclass">Violation date / Offense date</label>
        <input type="date" :max="new Date().toJSON().slice(0, 10)" :id="violationDateField" :aria-describedby="`${violationDateField}Desc`"
              v-model="myViolationDate" @input="validateViolationSuspensionDate" aria-required="true" />
        </div>
        <div class="conjunction">OR</div>
        <div class="app-input-group app-input-model" :class="{ 'app-invalid-group': !isViolationDateSupported }">
        <label :for="suspensionDateField" class="inputclass">Suspension effective date</label>
        <input type="date" :id="suspensionDateField" :aria-describedby="`${suspensionDateField}Desc`"
              v-model="mySuspensionDate" @input="validateViolationSuspensionDate" aria-required="true" />
        </div>
        <p v-if="!isViolationDateSupported" class="app-error-message-violation-suspension app-error-group">{{ violationError }}</p>
        <p :id="`${violationDateField}Desc`" class="sr-only">{{ getFieldDescription(`${violationDateField}`) }}</p>
        <p id="violationDesc" class="sr-only">Required in mm/dd/yyyy format.</p>
      </div>
      <div class="app-input-empty-row" v-if="selectId == 3"></div>

    <!-- /* This div will open when user selects crash record*/ -->
    <div class="app-input-row"  v-if="selectId == 4">
      <div class="app-input-group" :class="{ 'app-invalid-group': !isCrashDateSupported }">
      <label :for="crashDateField" class="inputclass">Date of crash</label>
      <input type="date" :max="new Date().toJSON().slice(0, 10)" :id="crashDateField" :aria-describedby="`${crashDateField}Desc`"
            v-model="myCrashDate" @input="validateCrashDate" aria-required="true" />
      <p v-if="!isCrashDateSupported" class="app-error-message">{{ crashDateError }}</p>
      <p :id="`${crashDateField}Desc`" class="sr-only">{{ getFieldDescription(`${crashDateField}`) }}</p>
      <p id="crashDateDesc" class="sr-only">Required in mm/dd/yyyy format.</p>
      </div>

      <div class="app-input-group" :class="{ 'app-invalid-group': !isCrashLocationValid }">
        <label :for="crashLocationField" class="inputclass">Crash location</label>
        <select class="app-custom-select" :id="crashLocationField" :aria-describedby="`${crashLocationField}Desc`"
                v-model.lazy="myCrashLocation" aria-required="true">
          <option :value="{ code: 'none' }">Select</option>
          <option v-for="type in crashLocations" :value="{ code: type.cityId, description: type.description }" :key="type.cityId">
            {{ type.description }}
          </option>
        </select>
        <p v-if="!isCrashLocationValid" class="app-error-message">{{ crashLocationError }}</p>
        <p :id="`${crashLocationField}Desc`" class="sr-only">{{ getFieldDescription(`${crashLocationField}`) }}</p>
      </div>
    </div>
    

    <BaseButtonGroup>
      <CustomButton @click="onLogin">
        Sign in
      </CustomButton>        
    </BaseButtonGroup>
  </form>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import * as COMMONS from '../../../store/_commons'
import vu from '@/utils/validationUtils'
import BaseButtonGroup from '@/components/ui/BaseButtonGroup'
import { isAfter, parse, toDate } from "date-fns";
import CustomButton from '../../CustomButton.vue';


export default {
  name: "Loginform",
  components: {
    BaseButtonGroup,
    CustomButton
  },
  props: [
    'selectId'
  ],
  data() {
    return {
      nameField: 'lastName',
      ssnField: 'lastFourDigitsOfSsn',
      dateField: 'dateOfBirth',
      inputType: 'password',
      licenseField: 'licenseNumber',
      ddNumberField: 'ddNumber',

      plateField: 'plateNumber',
      typeField: 'plateType',
      vinField: 'vinNumberLastSix',

      caseNumberField: 'caseNumber',
      suspensionDateField:'suspensionDate',
      violationDateField:'violationDate',
      crashDateField: 'crashDate',
      crashLocationField: 'crashLocation',

      namePattern: /^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/,
      caseNumPattern: /^[a-zA-Z0-9!@#$%^&*()_+-=[\]{}\u2018\u2019':"\\.>/?|`~ ]*$/,
      numericPattern: /^[0-9]+$/,
      inputPattern: /^[a-zA-Z0-9]*$/,
      myName: '',
      myLastSsn: '',
      myDob: undefined,
      myLicense: '',
      myddNum: '',
      myPlateNumber: '',
      myPlateType: { code: 'none' },
      myLastVin: '',

      isNameValid: true,
      isSsnValid: true,
      isDateSupported: true,
      isModify: false,
      errorCode: undefined,
      isLicenseValid: true,
      isddNumberValid: true,

      isPlateValid: true,
      isTypeValid: true,
      isVinValid: true,
      isCaseNumberValid: true,
      isViolationDateSupported: true,
      isSuspensionDateSupported: true,
      isCrashDateSupported: true,
      isCrashLocationValid: true,

      myCaseNumber: '',
      myViolationDate: undefined,
      mySuspensionDate: undefined,
      myCrashDate: undefined,
      myCrashLocation: { code: 'none' },

      violationErrorCode: undefined,
      suspensionErrorCode: undefined,
      crashDateErrorCode: undefined,

      caseNumberDescription: 'You can get this information on the RI DMV’s Notice of action that was mailed to you. ' + 
                             '<br />OR <br />' +
                             'On the RI Courts public portal at <br />' + 
                             '<a href="https://publicportal.courts.ri.gov/PublicPortal" target="_blank" rel="noopener noreferrer">https://publicportal.courts.ri.gov/PublicPortal</a>'
    }
  },
  computed: {
    ...mapGetters({
      statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO,
      lookupInfo: COMMONS.VEHICLE_LOOKUP_INFO,
      crashLookupInfo: COMMONS.GUEST_LOGIN_LOOKUP_INFO,
    }),

    registrationTypes() {
      return this.lookupInfo.allRegistrationTypes;
    },
    crashLocations() {
      let sortCityName = []
      if(this.crashLookupInfo.allCrashLocation) {
        sortCityName = this.crashLookupInfo.allCrashLocation.slice().sort((a,b) => {
          return a.description.localeCompare(b.description); 
        });
      }
      return sortCityName;
    },
    nameError() {
      const isNameValid = (this.myName.length > 0) && this.namePattern.test(this.myName) && this.myName.length < 40;
        if (!isNameValid) {
        const val = this.myName;

        let errorCode = undefined;
        if (val.length <= 0) {
          errorCode = '01';       
        }

        // override empty field error message
        if (!(this.namePattern.test(val))) {
          errorCode = '02';       // no special chars
        }
        if (this.myName.length > 40) {
          errorCode = '03';
        }
          return this.getFieldErrorMessage(this.nameField, errorCode);
        }

        return '';
    },
    ssnError() {
      if (!this.isSsnValid) {
        return this.getFieldErrorMessage(this.ssnField);
      }

      return '';
    },
    dobError() {
      if (!this.isDateSupported) {
        return this.getFieldErrorMessage(this.dateField, this.errorCode);
      }
      return '';
    },
    licenseError() {
      const isLicenseValid = (this.myLicense.length > 6) && this.namePattern.test(this.myLicense) && this.myLicense.length <= 8;
        if (!isLicenseValid) {
        const val = this.myLicense;

        let errorCode = undefined;
        if (val.length < 7) {
          errorCode = '07';       
        }

        // override empty field error message
        if (!(this.namePattern.test(val))) {
          errorCode = '07';       // no special chars
        }
          return this.getFieldErrorMessage(this.licenseField, errorCode);
        }

        return '';
    },
    ddError() {
      const isddNumberValid = (this.myddNum.length > 0) && this.numericPattern.test(this.myddNum) && this.myddNum.length <= 10 && this.myddNum !=='1';

      if (!isddNumberValid) {
        const val = this.myddNum;

        let errorCode = undefined;
        if (val.length <= 0) {
          errorCode = '08';       
        }

        // override empty field error message
        if (!this.numericPattern.test(val) ||  this.myddNum !=='1') {
          errorCode = '08';       // no special chars
        }
        if (this.myddNum.length > 10) {
          errorCode = '09';
        }
          return this.getFieldErrorMessage(this.ddNumberField, errorCode);
        }

        return '';
    },
    plateError() {
      if (!this.isPlateValid) {
        return this.getFieldErrorMessage(this.plateField);
      }

      return '';
    },
    typeError() {
      if (!this.isTypeValid) {
        return this.getFieldErrorMessage(this.typeField);
      }

      return '';
    },
    vinError() {
      if (!this.isVinValid) {
        return this.getFieldErrorMessage(this.vinField);
      }
      return '';
    },
    caseNumberError() {
      const isCaseNumberValid = (this.myCaseNumber.length > 0) && this.caseNumPattern.test(this.myCaseNumber) && this.myCaseNumber.length <= 18 ;

      if (!isCaseNumberValid) {
        const val = this.myCaseNumber;

        let errorCode;
        if (val.length <= 0) {
          errorCode = '10';       
        }

        // override empty field error message
        // if (!this.numericPattern.test(val) ||  this.myCaseNumber !=='1') {
        //   errorCode = '08';       // no special chars
        // }
        if (this.myCaseNumber.length > 18) {
          errorCode = '11';
        }
          return this.getFieldErrorMessage(this.caseNumberField, errorCode);
        }

        return '';
    },
    violationError() {
      if (!this.isViolationDateSupported) {
        return this.getFieldErrorMessage(this.violationDateField, this.violationErrorCode);
      }
      return '';
    },
    crashDateError() {
      if (!this.isCrashDateSupported) {
        return this.getFieldErrorMessage(this.crashDateField, this.crashDateErrorCode);
      }
      return '';
    },
    crashLocationError() {
      if (!this.isCrashLocationValid) {
        return this.getFieldErrorMessage(this.crashLocationField);
      }
      return '';
    },
    /**
     * Error codes and messages mapped from BA's spreadsheet.
     * Used for generating form validation messages and 508-compliant field descriptions.
     *  - Validation (error) messages are per _code_ based on user input. A field can have more than one codes.
     *  - Accessible field description is per _field_.
     * @returns {({ref: string, message: string}|...)[]}
     */
    validationMessages() {
      return [
      { ref: this.nameField, code: '01', message: 'Last name is required' },
      { ref: this.nameField, code: '02',  message: 'Special characters ";", "<", "|", "," and "-" are not allowed.' + 'For hyphenated names please use a space in place of hyphen / dash.'},
      { ref: this.nameField, code: '03', message: 'Last name is limited to 40 characters' },
      { ref: this.ssnField,  code: '04', message: 'Last four digits of SSN is required'},  
      { ref: this.dateField, code: '05', message: 'A valid Date of birth is required' },
      { ref: this.dateField, code: '06', message: 'Date must be within the acceptable range.' },
      { ref: this.licenseField, code: '07', message: 'A valid RI License # or State ID # is required' },
      { ref: this.ddNumberField, code: '08', message: 'A valid DD # is required. Please refer to the image for help on where to locate the DD # on your License / ID card.' },
      { ref: this.ddNumberField, code: '09', message: 'DD # is limited to 10 characters. Please refer to the image for help on where to locate the DD # on your License / ID card.' },  
      { ref: this.plateField, message: 'Plate number is required. ' +
              'Acceptable characters are letters or numbers. Please do not include dashes or spaces.' },
      { ref: this.typeField, message: 'Plate type is required.' },
      { ref: this.vinField, message: 'Last six digits of VIN are required, you must enter all six digits. ' +
              'Acceptable characters are letters or numbers.' },   
      { ref: this.caseNumberField, code: '10', message: 'Case / Summons / Ticket number is required' }, 
      { ref: this.caseNumberField, code: '11', message: 'Case / Summons / Ticket number is limited to 18 characters' },  
      { ref: this.violationDateField, code: '12', message: 'A valid Violation / Offense date ' + 'OR' + ' Suspension effective date is required' },  
      // { ref: this.violationDateField, code: '13', message: 'A valid Violation / Offense date ' + 'OR' + ' Suspension effective date is required' },  
      { ref: this.crashDateField, code: '14', message: 'A valid Date of crash is required' },  
      { ref: this.crashDateField, code: '15', message: 'Date of crash should not be a future date' }, 
      { ref: this.crashLocationField, code: '16', message: 'Crash location is required' },
    ];
    },
  },
  methods: {
    ...mapActions({
      getGuestLogin: COMMONS.GUEST_LOGIN_GET_LOGIN,
      setGuestLoginData: COMMONS.GUEST_LOGIN_SET_DATA,
      getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
      getTypeList: COMMONS.VEHICLE_GET_TYPE_LIST,
      setData: COMMONS.VEHICLE_SET_DATA,
      getCrashLocation: COMMONS.GUEST_CRASH_LOCATION,
      getGuestLoginRequest: COMMONS.GUEST_LOGIN_GET_LOGIN_REQUEST
    }),
    getFieldErrorMessage(ref, code=undefined) {
      return vu.getFieldValidationMessage(this.validationMessages, ref, code);
    },
    getFieldDescription(ref) {
      return vu.getFieldAccessibleDescription(this.validationMessages, ref);
    },
    onlyNumbers(event, vModel) {
        this[vModel] = event.target.value.replace(/[^0-9]/g, '');
        this.validateSsn();
    },
    toggleHidden() {
      this.inputType = this.inputType === "password" ? "text" : "password";       
    },
    onLogin() {
      

      if (this.validate()) {
        this.setGuestLoginData({
          loginTypeId: this.selectId,
          customerName: this.myName,
          dateOfBirth: this.myDob,

          lastFourDigitsOfSsn: this.myLastSsn,
          licenseNumber: this.myLicense,

          plateNumber: this.myPlateNumber,
          plateType: this.myPlateType,
          vinLastSix: this.myLastVin,

          caseSummonTicketNumber: this.myCaseNumber,
          suspensionEffectiveDate: this.mySuspensionDate,
          violationDate: this.myViolationDate,

          crashDate: this.myCrashDate,
          crashLocation: this.myCrashLocation,
        })
        this.getGuestLoginRequest();
      }
    },
    validateName() {
      const val = this.myName;
      this.isNameValid = (val.length > 0) && this.namePattern.test(val) && val.length <= 40;
    },
    validateSsn() {
      const val = this.myLastSsn;
      this.isSsnValid = (val.length === 4);
    },
    validateDob() {
      this.errorCode = undefined;
      let value = this.myDob;
        if (!value) {
            this.errorCode = '05';
        }
        // plain text input field intervention
        else {
          if ((value?.match(/\d{2}\/\d{2}\/\d{4}$/g) || []).length === 1) {
            const tmp = value;
            value = `${tmp.substr(6, 4)}-${tmp.substr(0, 2)}-${tmp.substr(3, 2)}`;
          }

          const minDate = toDate(new Date(1751, 11, 31, 23, 59, 59));
          const curDate = parse(value, 'yyyy-MM-dd', new Date());

          if(!isAfter(curDate, minDate)) {
            this.errorCode = '06';
          }
        }
        this.isDateSupported = this.errorCode ? false : true;
    },
    validateLicense() {
      const val = this.myLicense;
      this.isLicenseValid = (val.length > 6) && this.namePattern.test(val) && val.length <= 8;
    },
    validatePlate() {
      const val = this.myPlateNumber;
      this.isPlateValid = ((val.length > 0 && val.length <= 7) && this.inputPattern.test(val));
    },
    validateType() {
      this.isTypeValid = (this.myPlateType.code !== 'none');
    },
    validateVin() {
      const val = this.myLastVin;
      this.isVinValid = (val.length === 6 && this.inputPattern.test(val));
    },
    validateCaseNumber() {
      const val = this.myCaseNumber;
      this.isCaseNumberValid = (val.length > 0) && this.caseNumPattern.test(val) && val.length <= 18 ;
    },
    validateViolationSuspensionDate() {
      this.violationErrorCode = undefined;
      let violationValue = this.myViolationDate;
      let suspensionValue = this.mySuspensionDate
        if (!violationValue && !suspensionValue) {
            this.violationErrorCode = '12';
        }
        // plain text input field intervention
        else {
          if ((violationValue?.match(/\d{2}\/\d{2}\/\d{4}$/g) || []).length === 1) {
            const tmp = violationValue;
            violationValue = `${tmp.substr(6, 4)}-${tmp.substr(0, 2)}-${tmp.substr(3, 2)}`;
          }
          if((suspensionValue?.match(/\d{2}\/\d{2}\/\d{4}$/g) || []).length === 1) {
            const tmp = suspensionValue;
            suspensionValue = `${tmp.substr(6, 4)}-${tmp.substr(0, 2)}-${tmp.substr(3, 2)}`;
          }
          const minDate = toDate(new Date(1751, 11, 31, 23, 59, 59));
          const maxDate = toDate(new Date());
          
          if(violationValue!=null && violationValue!=''){
            const curDateViolation = parse(violationValue, 'yyyy-MM-dd', new Date());
            if(!isAfter(curDateViolation, minDate)) {
              this.violationErrorCode = '12';
            }
            if(!isAfter(maxDate, curDateViolation)) {
              this.violationErrorCode = '12';
            }
          }
          
          if(suspensionValue!=null && suspensionValue!='') {
            const curDateSuspension = parse(suspensionValue, 'yyyy-MM-dd', new Date());
            if(!isAfter(curDateSuspension, minDate)) {
              this.violationErrorCode = '12';
            }
          }
        }
      this.isViolationDateSupported = this.violationErrorCode ? false : true;
    },

    validateCrashDate() {
      this.crashDateErrorCode = undefined;
      let value = this.myCrashDate;

        if (!value) {
            this.crashDateErrorCode = '14';
        }
        // plain text input field intervention
        else {
          if ((value?.match(/\d{2}\/\d{2}\/\d{4}$/g) || []).length === 1) {
            const tmp = value;
            value = `${tmp.substr(6, 4)}-${tmp.substr(0, 2)}-${tmp.substr(3, 2)}`;
          }
          
          const minDate = toDate(new Date(1751, 11, 31, 23, 59, 59));
          const maxDate = toDate(new Date());
          
          if(value!=null){
            const curDate = parse(value, 'yyyy-MM-dd', new Date());
            if(!isAfter(curDate, minDate)) {
              this.crashDateErrorCode = '14';
            }
            if(!isAfter(maxDate, curDate)) {
              this.crashDateErrorCode = '14';
            }
          }
        }
        this.isCrashDateSupported = this.crashDateErrorCode ? false : true;
    },
    validateCrashLocation() {
      this.isCrashLocationValid = (this.myCrashLocation.code !== 'none');
    },

    validate() {
      if(this.selectId == 1) {
        this.validateName();
        this.validateSsn();
        this.validateDob();
        this.validateLicense();
        return this.isNameValid && this.isSsnValid && this.isDateSupported && this.isLicenseValid;
      }
      else if(this.selectId == 2) {
        this.validateName();
        this.validateDob();
        this.validatePlate();
        this.validateType();
        this.validateVin();
        return this.isNameValid && this.isDateSupported && this.isPlateValid && this.isTypeValid && this.isVinValid;
      }
      else if(this.selectId == 3) {
        this.validateName();
        this.validateDob();
        this.validateCaseNumber();
        this.validateViolationSuspensionDate();
        return this.isNameValid && this.isDateSupported && this.isCaseNumberValid && this.isViolationDateSupported;
      }
      else if(this.selectId == 4) {
        this.validateName();
        this.validateDob();
        this.validateCrashDate();
        this.validateCrashLocation();
        return this.isNameValid && this.isDateSupported && this.isCrashDateSupported && this.isCrashLocationValid;
      }
    },
    getLogout() {
      this.getGuestLogout();
    },

    getFormReset() {
      this.myName = '';
      this.myLastSsn = '';
      this.myDob = undefined;
      this.myLicense = '';
      this.myPlateNumber= '';
      this.myPlateType = { code: 'none' };
      this.myLastVin = '';
      this.myCaseNumber = '';
      this.myViolationDate = '';
      this.mySuspensionDate = '';
      this.myCrashDate = '';
      this.myCrashLocation = { code: 'none' };
      
      this.isNameValid = true;
      this.isSsnValid = true;
      this.isDateSupported = true;
      this.isModify = false;
      this.errorCode = undefined;
      this.isLicenseValid = true;
      this.isddNumberValid = true;
      this.isPlateValid = true;
      this.isTypeValid = true;
      this.isVinValid = true;
      this.isCaseNumberValid = true;
      this.isViolationDateSupported = true;
      this.isSuspensionDateSupported = true;
      this.isCrashDateSupported = true;
      this.isCrashLocationValid = true;

      this.$store.state.networkResponse = null
    },
    // setDateField() {
    //   /* patch for macOS Safari */
    //   const ua = window.navigator.userAgent;
    //   // is it Safari?
    //   const isSafari = ua.includes('Version/');
    //   // is it mobile (phone)?
    //   const isMobile = ua.includes('Mobile');
    //   this.isDateSupported = !(isSafari && !isMobile);  // tablets and macOS Safari users
    // },
    /**
     * TASK 943720 ~ Patch for macOS Safari.
     * @param dt
     * @returns {string|*}
     */
    reformatDob(dt) {
      if ((dt.match(new RegExp(/^\d{4}-\d{2}-\d{2}.*/, 'g')) || []).length === 1) {
        return `${dt.substr(5, 2)}/${dt.substr(8, 2)}/${dt.substr(0, 4)}`;
      }
      return dt;
    },
    trimDob(dt) {
      // patch for older macOS Safari
      const dob = (dt && !this.isDateSupported) ? this.reformatDob(dt) : dt;

      // verify .includes in next iteration
      const t = dob ? dob.indexOf('T') : dob;
      if (t > -1) {
        return dob.substr(0, t);
      }
      return dob;
    },
  },
  created() {
    this.getTypeList();
    this.getCrashLocation();
    if(this.$store.state.guestLogin.accessToken) {
      this.getLogout();
    }
  },
  mounted() {
    window.onpopstate = event => {
      console.log(" this is ", event)
      this.validate(event);
    }
  },
  // beforeDestroy() {
  //   this.validate();
  // }
  beforeRouteUpdate() {
    this.validate();
  }
}
</script>

<style lang="scss" scoped>
  .quote-lookup-form {
    select, input {
      min-width: 230px;
    }
    input.short {
      min-width: unset;
      max-width: 6rem;
    }
  }
.req-field{
  margin-top: 1rem;
}
  .app-input-group {
    .app-btn-image {
      width: 44px;
      height: 44px;
      margin-left: 0.45em;
      img {
        width: 18px;
      }
    }
    .inputclass {
      margin-bottom: 12px;
      .subText {
        font-size: 13px;
      }
    }

    .license-image {
      width: 100%;
    }

    .d-flex{
      display: flex;
    }

    .tooltip {
      .tooltip-inner {
        max-width: 400px !important;
      }
    }
  }
  .fourdigitssn{
    width: 6.25em;
    border: 1px solid #293557;
    border-radius: 6px;
    height: 2.5em;
    padding: 0.5em 1em;
  }
  /* Hide password reveal button in MS Edge */
  ::-ms-reveal {
    display: none;
  }
  .conjunction {
    // do not use flex alignment due to conditional error <p>
    line-height: 2em;
    padding: 0 0.75em;
    margin-top: 2.5rem;
    @media (min-width: 355px) and (max-width: 500px) {
      margin-top: 0em;
      width: 60%;
      margin-left: 4em;
    }
  }

  .app-error-message-violation-suspension{
    color: var(--ri-red);
  }
  .app-input-model{
    margin-bottom: 0em !important;
  }
  .app-error-group{
    padding-top: 0em !important;
  }
  .app-input-empty-row{
    margin-bottom: 0.75em;
  }
</style>

 




